<template>
    <div>
        <el-form :model="ruleForm" label-width="100px">

            <!-- 协议名称 -->
            <el-form-item label="协议名称">
                <span>{{ruleForm.title}}</span>
            </el-form-item>

            <!-- 协议说明 -->
            <el-form-item label="协议说明">
                <span>{{ruleForm.description}}</span>
            </el-form-item>

            <!-- 服务方 -->
            <el-form-item label="服务方">
                <span>{{ruleForm.server && ruleForm.server.name}}</span>
            </el-form-item>

            <!-- 客户合同 -->
            <el-form-item label="客户合同">
                <router-link :to="{ path: '/serveBargainDetail',
                                    query: { serialNumber: ruleForm.contract.serialNumber}}">
                    <el-button type="text">{{ruleForm.contract.title}}</el-button>
                </router-link>
            </el-form-item>

            <!-- 相应时长 -->
            <el-form-item label="响应时长">
                <span>{{ruleForm.responseTime}}</span>
            </el-form-item>

            <!-- 完成时长 -->
            <el-form-item label="完成时长">
                <span>{{ruleForm.completionTime}}</span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: {
            form: Object
        },

        data() {
            return {
                ruleForm: {}
            }
        },

        created() {
            this.ruleForm = { ...this.form }
        },
    }
</script>

<style lang="scss" scoped>

</style>
